// Period presets shared by the P2 admin screens (mail queue, audit log).
//
// The lower bound is captured INTO STATE at selection time (never derived in
// render): a render-time `Date.now()` would change the query key on every
// render and re-fire the query (same reasoning as LlmPeriodFilter presets).
export type AdminPeriodPreset = 'all' | '24h' | '7d' | '30d';

const PERIOD_PRESET_MS: Record<Exclude<AdminPeriodPreset, 'all'>, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
};

export const ADMIN_PERIOD_PRESETS: readonly AdminPeriodPreset[] = ['all', '24h', '7d', '30d'];

export interface AdminPeriodState {
  preset: AdminPeriodPreset;
  /** ISO lower bound; `undefined` for the "all time" preset. */
  from: string | undefined;
}

/** Builds the state for a preset; call it in onChange, not in render. */
export function makeAdminPeriodState(preset: AdminPeriodPreset): AdminPeriodState {
  return {
    preset,
    from:
      preset === 'all' ? undefined : new Date(Date.now() - PERIOD_PRESET_MS[preset]).toISOString(),
  };
}
